import { defineEnvelopeApiCaller } from '../ApiCaller';
import { PlacementRepo } from './PlacementRepo';

export const ListPlacementsApiCaller = defineEnvelopeApiCaller(
  PlacementRepo.listPlacementsCallKey,
  (options) => new PlacementRepo().listPlacements(options),
);
